
import React, { useState, useEffect } from "react";
import logo from "../../img/mustard_spray.gif";
import { Grid, Icon } from "semantic-ui-react";
import Draggable from "react-draggable"; // The default
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import Tickets from '../Tickets/Tickets'
import axiosInstance from "../../lib/auth/axiosApi";
import MustardBottleLoader from "../../components/MustardBottleLoader/MustardBottleLoader";

function DijonBeeminder(props) {

  const [goals, setGoals] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function getData() {
      let res = await axiosInstance.get("/beeminder/")
      setGoals(res.data.data.goals)
      setLoading(false)
    }
    getData()
  }, []);

  return (
    <div id="beeminder">
      <DijonCard
        width={'100%'}
        height={'82vh'}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={'beeminder'}
        content={
          <div className={"container mx-auto px-4"} style={{
              height: '100%',
              overflow: 'scroll',
              padding: '20px'
          }}>
            {loading &&
              <MustardBottleLoader />
            }
            <Grid>
              {goals?.map((goal) => (
                <Grid.Column width={4}>
                  <div className="goal" key={goal.id}>
                    <div className="goal-title">{goal.slug}</div>
                    <img style={{width: "100%", height: "auto"}}src={goal.graph_url} ></img>
                  </div>
                </Grid.Column>
              ))}
            </Grid>
          </div>
        }
      />

    </div>
  );
}

export default DijonBeeminder;
